import { render } from "./PasswordChangeDialog.vue?vue&type=template&id=0d34ac48"
import script from "./PasswordChangeDialog.vue?vue&type=script&lang=js"
export * from "./PasswordChangeDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../home/dory/Software/OrbiLog/docroot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__